export const paymentMethod = {
    CARD: 'card',
    BANK: 'bank',
    CASH: 'cash',
};
